import { differenceInDays } from "date-fns";
import { format, utcToZonedTime } from "date-fns-tz";
import React, { useEffect, useState, useContext } from "react";
import { useTranslation } from "react-i18next";
import { getDomainConfig } from "../../config/config";
import { useCart } from "../../hooks/useCart";
import { getLanguageCode } from "../../utils/getURLParams";
import { getTicketTitle } from "../../utils/cart.js";
import { ABContext } from "../../contexts/ab-context";
import { ReactComponent as InformationIcon } from '../../images/global/information.svg';
import { ReactComponent as CircleCheck } from '../../images/global/circle-check.svg';
import ReactHtmlParser from 'react-html-parser'
import MagicBandGirl from '../../images/global/girl-magicband.jpg';
import MagicBand from '../../images/global/magicband.png';
import {ReactComponent as BasketIcon} from '../../images/global/basket-logo.svg';
import {ReactComponent as GiftIcon} from '../../images/global/gift-green.svg';
import StandardH4 from "../UI/StandardH4";
import { formatCurrency } from "../../utils/formatCurrency.js";

const CartItems = (props) => {
  const config = getDomainConfig();
  const { t } = useTranslation('common');

 /* LOADING THE BRANDED SCSS */
 const [styles, setStyles] = useState(false);

 useEffect(() => {

  const getStyles = async (theFileName, theFileEnd) => {
   if (config.brand) {
     let moduleStyles = false;
     try {
       moduleStyles = await import(
         "./" + theFileName + config.brand + theFileEnd
       );
       setStyles(moduleStyles);
     } catch (e) {
       console.error(
         `Styles for ${theFileName} could not be loaded, ${e.message}`
       );
     }
   }
 };

   // Specify file name and end of file name here.
   getStyles("CartItems", ".module.scss");
 }, [config.brand]);

 /* END LOADING THE BRANDED SCSS */
  // CRO-1259
  const abContext = useContext(ABContext);
  const [isCro1259, setIsCro1259] = useState(false);

  useEffect(() => {
    if (abContext.cro1259 !== undefined) setIsCro1259(abContext.cro1259.variant);
  }, [abContext]);

  const magicBandId = "320292";

  const [isTooltipVisible, setIsTooltipVisible] = useState(false);

  const toggleTooltip = () => {
    setIsTooltipVisible(!isTooltipVisible);
  };

  // CRO-1259 END

  // CRO-1381-checkout-redesign
  const [isCro1381, setIsCro1381] = useState(false);

  useEffect(() => {
    if ((config.brand !== 'Sw') && abContext.cro1381 !== undefined) setIsCro1381(abContext.cro1381.variant);
  }, [abContext]);
  // END CRO-1381-checkout-redesign

  const { isSuccess: cartIsSuccess, data: cartContents } = useCart();

  let cartMeta = [];
  if (cartIsSuccess) {
    cartMeta = cartContents.meta;
  }

  let cartTickets = [];
  if (cartIsSuccess) {
    // // CRO-1295
    if (isCro1259) {
      cartContents.data.tickets.sort((a, b) => {
        const aHasTicketTag = a.tags.includes("ticket");
        const bHasTicketTag = b.tags.includes("ticket");

        const aIsSpecialTicket = a.ticket_id === magicBandId;
        const bIsSpecialTicket = b.ticket_id === magicBandId;

        if (aHasTicketTag && !bHasTicketTag) return -1;
        if (!aHasTicketTag && bHasTicketTag) return 1;

        if (aHasTicketTag && bHasTicketTag) {
          if (aIsSpecialTicket && !bIsSpecialTicket) return -1;
          if (!aIsSpecialTicket && bIsSpecialTicket) return 1;
          return 0;
        }

        if (aIsSpecialTicket && !bIsSpecialTicket) return -1;
        if (!aIsSpecialTicket && bIsSpecialTicket) return 1;
        return 0;
      });
    }
    // CRO-1259 END
    cartTickets = cartContents.data.tickets;
  }


  // Get the tickets and freebies separately.
  const cro1381CartTickets = cartIsSuccess ? cartContents.data.tickets.filter(ticket => ticket.tags.includes("ticket")) : [];
  const cro1381CartFreebies = cartIsSuccess ? cartContents.data.tickets.filter(ticket => ticket.tags.includes("freebie")) : [];

  return (
    <React.Fragment>
      {isCro1381 ?
      <tr>
        <td>
          {cro1381CartTickets.length > 0 &&
            <div className={styles.cro1381Ticket}>
              <div className={styles.cro1381TicketHeader}>
                <BasketIcon className={styles.cro1381Icon} />
                <StandardH4 className="cro1381BasketSidebarTitle">{t('Basket')}</StandardH4>
              </div>
              <div className={styles.cro1381TicketsFlex}>
                <StandardH4>{t('tickets')}</StandardH4>
                {config.brand === "Atd" && !cartMeta.is_hotel_cart && (
                  <div className={styles.checkoutBackToCart}><a href={getLanguageCode(config.brand,true) + "/cart"}>{t('back-to-basket')}</a></div>
                )}
              </div>
              <table>
                {cro1381CartTickets.length > 0 && cro1381CartTickets.map(cartItem => (
                  <>
                  <tr className={`${styles.tbodyTr} ${isCro1259 && cartItem.ticket_id === magicBandId ? styles.magicBand : ""}`} key={cartItem.cart_item_id}>
                    <td className={styles.qty}>{cartItem.qty}x&nbsp;</td>
                    <td className={styles.item}>
                    {cartItem.tags.some(tag => tag.includes('rooms')) && config.brand === 'Uo'
                    ? cartItem.data.attraction_title
                    : cartItem.tags.includes('combo')
                        ? `${cartItem.title}${cartItem.data.type_ticket && ` - ${cartItem.data.type_ticket}`}${cartItem.internal.price_option_title === 'Flex-Plus' ? ` (${cartItem.internal.price_option_title})` : ''}`
                        : ReactHtmlParser(getTicketTitle(cartItem))
                    }
                    {cartItem.tags.some((tag) => tag.includes('rooms')) && config.brand === 'Uo' ?
                    <>
                      <p><b>{format(utcToZonedTime(new Date(cartItem.attributes['5'][0]),'UTC'),'dd LLLL yyyy',{ timeZone: 'UTC' })} - {format(utcToZonedTime(new Date(cartItem.attributes['42'][0]),'UTC'),'dd LLLL yyyy',{ timeZone: 'UTC' })} ({differenceInDays(new Date(cartItem.attributes['42'][0]),new Date(cartItem.attributes['5'][0]))} {t('nights')})</b></p>
                      <p><b>{t('room')} {cartItem.tags[1].split('-')[1]}</b></p>
                      <p>{t('Adult')} {cartItem.attributes['48'][0]} {(+cartItem.attributes['49'][0] + +cartItem.attributes['87'][0]) > 0 && `, ${t('Children')} ${+cartItem.attributes['49'][0] + +cartItem.attributes['87'][0]}`}</p>
                      <p>{cartItem.data.room.title}</p>
                    </> : ''}
                    </td>
                  </tr>
                  <tr>
                    <td></td>
                    <td className={styles.cro1381Sum}>{cartItem.price > 0 && formatCurrency((cartItem.qty * cartItem.price).toFixed(2), props.geo)}</td>
                  </tr>
                  </>
                  ))}
                </table>
              </div>
            }
            {cro1381CartFreebies.length > 0 &&
              <div className={styles.cro1381Freebies}>
                <div className={styles.cro1381TicketFreebies}>
                  <GiftIcon className={styles.cro1381Icon} />
                  <StandardH4 className="cro1381FreebiesSidebarTitle">{t('free-gifts')}</StandardH4>
                </div>
                <table>
                  {cro1381CartFreebies.length > 0 && cro1381CartFreebies.map(cartItem => (
                    <tr className={`${styles.tbodyTr} ${isCro1259 && cartItem.ticket_id === magicBandId ? styles.magicBand : ""}`} key={cartItem.cart_item_id}>
                      <td className={styles.qty}>{cartItem.qty}x&nbsp;</td>
                      <td className={styles.item}>{cartItem.tags.some((tag) => tag.includes('rooms')) && config.brand === 'Uo' ? cartItem.data.attraction_title : ReactHtmlParser(getTicketTitle(cartItem))} {isCro1259 && cartItem.ticket_id === magicBandId && <>. RRP$20pp</>}
                      {cartItem.tags.some((tag) => tag.includes('rooms')) && config.brand === 'Uo' ?
                      <>
                        <p><b>{format(utcToZonedTime(new Date(cartItem.attributes['5'][0]),'UTC'),'dd LLLL yyyy',{ timeZone: 'UTC' })} - {format(utcToZonedTime(new Date(cartItem.attributes['42'][0]),'UTC'),'dd LLLL yyyy',{ timeZone: 'UTC' })} ({differenceInDays(new Date(cartItem.attributes['42'][0]),new Date(cartItem.attributes['5'][0]))} {t('nights')})</b></p>
                        <p><b>{t('room')} {cartItem.tags[1].split('-')[1]}</b></p>
                        <p>{t('Adult')} {cartItem.attributes['48'][0]} {(+cartItem.attributes['49'][0] + +cartItem.attributes['87'][0]) > 0 && `, ${t('Children')} ${+cartItem.attributes['49'][0] + +cartItem.attributes['87'][0]}`}</p>
                        <p>{cartItem.data.room.title}</p>
                      </> : ''}
                      </td>
                    </tr>
                    ))}
                </table>
              </div>
            }
          </td>
        </tr>
        :
        <>
          {cartTickets.length > 0 &&
            cartTickets
            .map((cartItem) => (
              <tr
                className={`${styles.tbodyTr} ${isCro1259 && cartItem.ticket_id === magicBandId ? styles.magicBand : ""}`}
                key={cartItem.cart_item_id}
                data-testid = 'ticket-row'
              >
                <td className={styles.qty} data-testid = 'ticket-qty'>{cartItem.qty}&nbsp;×</td>
                <td className={styles.item} data-testid = 'ticket-title'>{cartItem.tags.some((tag) => tag.includes('rooms')) && config.brand === 'Uo' ? cartItem.data.attraction_title : ReactHtmlParser(getTicketTitle(cartItem))}
                {isCro1259 && cartItem.ticket_id === magicBandId && (
              <>. RRP $20pp
              <div className={styles.cro1259MbContainer}>
                {isTooltipVisible && (
                  <div className={styles.cro1259MbTooltip}>
                    <div className={styles.cro1259MbTooltipTop}>
                      You have qualified <CircleCheck />
                    </div>
                    <div className={styles.cro1259MbTooltipMiddle}>
                      <img src={MagicBandGirl} alt="Magic Band Girl" />
                    </div>
                    <div className={styles.cro1259MbTooltipBottom}>
                      <div className={styles.cro1259MbTooltipBottomCol1}>
                        <img src={MagicBand} alt="Magic Band" />
                      </div>
                      <div className={styles.cro1259MbTooltipBottomCol2}>
                        FREE Disney Magic Band per person. RRP $20pp
                      </div>
                    </div>
                    <div className={styles.cro1259MbTooltipTriangle}></div>
                  </div>
                )}
                <InformationIcon onClick={toggleTooltip} />
              </div>
              </>
            )}
            {cartItem.tags.some((tag) => tag.includes('rooms')) && config.brand === 'Uo' ?
                <>
                  <p><b>{format(utcToZonedTime(new Date(cartItem.attributes['5'][0]),'UTC'),'dd LLLL yyyy',{ timeZone: 'UTC' })} - {format(utcToZonedTime(new Date(cartItem.attributes['42'][0]),'UTC'),'dd LLLL yyyy',{ timeZone: 'UTC' })} ({differenceInDays(new Date(cartItem.attributes['42'][0]),new Date(cartItem.attributes['5'][0]))} {t('nights')})</b></p>
                  <p><b>{t('room')} {cartItem.tags[1].split('-')[1]}</b></p>
                  <p>{t('Adult')} {cartItem.attributes['48'][0]} {(+cartItem.attributes['49'][0] + +cartItem.attributes['87'][0]) > 0 && `, ${t('Children')} ${+cartItem.attributes['49'][0] + +cartItem.attributes['87'][0]}`}</p>
                  <p>{cartItem.data.room.title}</p>
                </> : ''}
                    </td>
                <td className={styles.price} data-testid='ticket-price'>
                  {cartItem.price === "" && t('free')}
                  {cartItem.price > 0 && props.currency + (cartItem.qty * cartItem.price).toFixed(2)}
                </td>
              </tr>
            ))
          }
        </>
      }
    </React.Fragment>
  );
};

export default CartItems;
